import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  InputAdornment,
  MenuItem,
  TextField,
  Typography,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import CloseIcon from '@mui/icons-material/Close';
import React, {
  ChangeEvent,
  useEffect,
  useRef,
  useState,
  SetStateAction,
  Dispatch,
} from 'react';
import { KEY_READ_TEXT, KEY_WALK_TEXT } from '../../common/key';

const readColumns = [
  { title: '완독 권수', value: 1 },
  { title: '금메달 수', value: 2 },
];

const stepColumns = [
  { title: '누적 걸음수', value: 1 },
  { title: '학생 당 일평균 걸음수', value: 2 },
  { title: '금메달 수', value: 3 },
];

const writeColumns = [
  { title: '작성 글 수', value: 1 },
  { title: '금메달 수', value: 2 },
];

interface Props {
  title: string;
  setSelectItem: Dispatch<SetStateAction<number>>;
}

export const SwRankDropbox: React.FC<Props> = ({ title, setSelectItem }) => {
  const [rankItem, setRankItem] = useState<number>(0);

  useEffect(() => {
    setRankItem(title === KEY_READ_TEXT ? 1 : title === KEY_WALK_TEXT ? 1 : 1);
  }, [title]);

  return (
    <>
      <Box>
        <Box className='flex_start'>
          <Typography className='title'>순위 기준</Typography>
          <TextField
            sx={{ width: '15rem' }}
            select
            value={rankItem}
            onChange={evt => {
              setRankItem(Number(evt.target.value));
              setSelectItem(Number(evt.target.value));
            }}
          >
            {(title === KEY_READ_TEXT
              ? readColumns
              : title === KEY_WALK_TEXT
              ? stepColumns
              : writeColumns
            ).map((item: any, idx: number) => (
              <MenuItem key={`rank_item_${idx}`} value={item.value}>
                {item.title}
              </MenuItem>
            ))}
          </TextField>
        </Box>
      </Box>
    </>
  );
};
